import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-info-component',
  templateUrl: './info-component.component.html',
  styleUrls: ['./info-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoComponentComponent {

}
